var map = {
	"./pages/audit-trails/audit-trails.module": [
		"./src/app/pages/audit-trails/audit-trails.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"common",
		"pages-audit-trails-audit-trails-module"
	],
	"./pages/authenticate/authenticate.module": [
		"./src/app/pages/authenticate/authenticate.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-authenticate-authenticate-module~pages-categorize-categorize-module~pages-import-case-~35766a69",
		"common",
		"pages-authenticate-authenticate-module"
	],
	"./pages/authentication/forgot-password/forgot-password.module": [
		"./src/app/pages/authentication/forgot-password/forgot-password.module.ts",
		"pages-authentication-forgot-password-forgot-password-module"
	],
	"./pages/authentication/login/login.module": [
		"./src/app/pages/authentication/login/login.module.ts",
		"pages-authentication-login-login-module"
	],
	"./pages/authentication/register/register.module": [
		"./src/app/pages/authentication/register/register.module.ts",
		"pages-authentication-register-register-module"
	],
	"./pages/case/case.module": [
		"./src/app/pages/case/case.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"pages-case-case-module"
	],
	"./pages/categorize/categorize.module": [
		"./src/app/pages/categorize/categorize.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"default~pages-authenticate-authenticate-module~pages-categorize-categorize-module~pages-import-case-~35766a69",
		"default~pages-categorize-categorize-module~pages-import-case-import-case-module",
		"common",
		"pages-categorize-categorize-module"
	],
	"./pages/companies/companies.module": [
		"./src/app/pages/companies/companies.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"default~pages-companies-companies-module~pages-import-case-import-case-module~pages-medicines-medici~bc3108c7",
		"common",
		"pages-companies-companies-module"
	],
	"./pages/components/components.module": [
		"./src/app/pages/components/components.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"pages-components-components-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"common",
		"pages-dashboard-dashboard-module"
	],
	"./pages/import-case/import-case.module": [
		"./src/app/pages/import-case/import-case.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"default~pages-authenticate-authenticate-module~pages-categorize-categorize-module~pages-import-case-~35766a69",
		"default~pages-companies-companies-module~pages-import-case-import-case-module~pages-medicines-medici~bc3108c7",
		"default~pages-import-case-import-case-module~pages-precaso-precaso-module",
		"default~pages-categorize-categorize-module~pages-import-case-import-case-module",
		"pages-import-case-import-case-module"
	],
	"./pages/meddra/meddra.module": [
		"./src/app/pages/meddra/meddra.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"default~pages-authenticate-authenticate-module~pages-categorize-categorize-module~pages-import-case-~35766a69",
		"pages-meddra-meddra-module"
	],
	"./pages/medicines/medicines.module": [
		"./src/app/pages/medicines/medicines.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"default~pages-authenticate-authenticate-module~pages-categorize-categorize-module~pages-import-case-~35766a69",
		"default~pages-companies-companies-module~pages-import-case-import-case-module~pages-medicines-medici~bc3108c7",
		"pages-medicines-medicines-module"
	],
	"./pages/precaso/precaso.module": [
		"./src/app/pages/precaso/precaso.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"default~pages-authenticate-authenticate-module~pages-categorize-categorize-module~pages-import-case-~35766a69",
		"default~pages-companies-companies-module~pages-import-case-import-case-module~pages-medicines-medici~bc3108c7",
		"default~pages-import-case-import-case-module~pages-precaso-precaso-module"
	],
	"./pages/profile/profile.module": [
		"./src/app/pages/profile/profile.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"pages-profile-profile-module"
	],
	"./pages/reportes/reportes.module": [
		"./src/app/pages/reportes/reportes.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"default~pages-authenticate-authenticate-module~pages-categorize-categorize-module~pages-import-case-~35766a69",
		"default~pages-companies-companies-module~pages-import-case-import-case-module~pages-medicines-medici~bc3108c7",
		"pages-reportes-reportes-module"
	],
	"./pages/role-requests/role-requests.module": [
		"./src/app/pages/role-requests/role-requests.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"pages-role-requests-role-requests-module"
	],
	"./pages/users/users.module": [
		"./src/app/pages/users/users.module.ts",
		"default~pages-audit-trails-audit-trails-module~pages-authenticate-authenticate-module~pages-case-cas~957d5722",
		"default~pages-audit-trails-audit-trails-module~pages-case-case-module~pages-categorize-categorize-mo~53284b99",
		"common",
		"pages-users-users-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;